import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CustomerListRequestBody, CustomerListResponse } from "./types";

export class CustomerListAPI extends BaseAPI<
  CustomerListRequestBody,
  CustomerListResponse
> {
  protected route = ApiRoutes.customer.list;
  protected method = RequestMethod.GET;
  protected params = ["sort_key", "sort_order"];
}
